enum OnlineOrderModeType {
  ViewMenu = 1,
  PlaceOrder
}

export default OnlineOrderModeType
